import React, { useState } from "react";
import SubmissionPopup from "./SubmissionPopup";
import SendIcon from '../assests/sendIcon.png'
import classes from './SubmitBtn.module.css';
import { useSelector } from "react-redux";
import SuccessSubmissionPopup from "./SuccessSubmissionPopup";
import { ActivityTypeEnum } from "../models/ActivityTypeEnum";

const SubmitBtn = ({ lessonParticipant, assessmentId, submissionId, activityType, studyGroupId, saveProjectCallback, setAssesmentStatus, setShowReflection, setPopupAssessmentLesson }) => {

    const [popup, setPopup] = useState()

    const { direction, texts } = useSelector((state) => state.translate);

    const closePopup = () => {
        setPopup(null);
        setPopupAssessmentLesson && setPopupAssessmentLesson(false);
        setShowReflection && setShowReflection(true);
    }

    const handleClick = () => {
        setPopup(<SubmissionPopup
            lessonParticipant={lessonParticipant}
            activityType={activityType}
            studyGroupId={studyGroupId}
            close={() => setPopup(null)}
            assessmentId={assessmentId}
            submissionId={submissionId}
            setSuccessSubmissionPopup={() => setPopup(<SuccessSubmissionPopup activityType={activityType} setPopupAssessmentLesson={setPopupAssessmentLesson} close={() => closePopup()} />)}
            saveProjectCallback={saveProjectCallback}
            setAssesmentStatus={setAssesmentStatus} />)
    }

    return (
        <div className={`${classes[direction]} ${classes.StatusContainer}`}>

            <button className={classes.SubmissionBtn} onClick={handleClick}>
                {ActivityTypeEnum[activityType] === ActivityTypeEnum.Final ? texts.submission : texts.save}
                {ActivityTypeEnum[activityType] === ActivityTypeEnum.Final ? <img className={classes.icon} src={SendIcon} alt="SendIcon" /> : ''}
            </button>

            {popup}
        </div>
    )
}
export default SubmitBtn;